<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import PortalView from "../../../../../component/common/Portal/PortalView.svelte";
    import DialogView from "../../../../../component/common/Dialog/DialogView.svelte";
    import LabelValueView from "../../../../../component/common/Value/LabelValueView.svelte";
    import InputAreaView from "../../../../../component/common/Form/InputAreaView.svelte";
    import ButtonView from "../../../../../component/common/Button/ButtonView.svelte";
    import {UrlUtil} from "../../../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../../../lib/Common/Http/HttpRequestUtil";

    const dispatcher = createEventDispatcher();
    export let binary;

    let newTagNames = '';
    let isLoading = false;

    onMount(() => {
    });

    function onShow() {

    }


    function onClickSave() {
        const paramMap = {};
        paramMap['space_id'] = binary.space_id;
        paramMap['app_id'] = binary.app_id;
        paramMap['binary_id'] = binary.id;
        paramMap['tag_names'] = newTagNames;


        const url = UrlUtil.createApiUrl("binary_tag");

        isLoading = true;
        HttpRequestUtil.postRequest(url, paramMap, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];

            newTagNames = '';

            dispatcher('update');

            dispatcher('close');
        });
    }

</script>

<PortalView>
    <DialogView isShow={binary != null} on:show={onShow} on:close title="バイナリタグの追加">
        <div class="binary-tag-add-dialog-content">
            {#if binary != null}
                <div>
                    <LabelValueView label="バイナリ名" value={binary.name}/>
                </div>
                <div>
                    <InputAreaView label="新規タグ">
                        <input type="text" bind:value={newTagNames} placeholder="スペースで区切ると複数のタグを一気に登録できます"/>
                    </InputAreaView>

                </div>
                <div class="button-area">
                    <ButtonView isPrimary={true} text="登録" on:click={onClickSave}/>
                </div>
            {/if}
        </div>

    </DialogView>
</PortalView>


<style lang="scss">
    .binary-tag-add-dialog-content {
        .button-area {
            text-align: center;
        }
    }
</style>